module.exports = __webpack_public_path__ + "media/images/ninestars/hero-img-436b051a167d76e28779acd677287f5c.svg";